import React, { useEffect, useState } from "react";
import { MailCheck } from "lucide-react";
import api from "../../lib/api";
import { toast } from "sonner";

export default function NurtureSettingsCard() {
  const [s, setS] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/admin/enterprise360/nurture-settings").then(({ data }) => setS(data)).catch(() => {});
  }, []);

  const save = async (next) => {
    setBusy(true);
    try {
      const { data } = await api.put("/admin/enterprise360/nurture-settings", next);
      setS(data); toast.success("Nurture settings saved");
    } catch { toast.error("Could not save"); } finally { setBusy(false); }
  };

  if (!s) return null;
  return (
    <div data-testid="nurture-settings" className="border border-zinc-200 rounded-lg p-4 flex items-center justify-between gap-4 flex-wrap">
      <div className="flex items-start gap-3">
        <MailCheck size={18} className="text-[var(--e360-primary)] mt-0.5" />
        <div>
          <div className="text-[13px] font-semibold text-black">Lead nurture sequence</div>
          <p className="text-[12px] text-zinc-500 max-w-md">
            Automatically send one reciprocal follow-up (self-assessment ↔ framework library) a few days after a lead comes in.
          </p>
        </div>
      </div>
      <div className="flex items-center gap-4">
        <label className="flex items-center gap-1.5 text-[12px] text-zinc-600">
          after
          <input data-testid="nurture-delay" type="number" min="0" max="60" value={s.delay_days} disabled={busy}
            onChange={(e) => setS({ ...s, delay_days: Number(e.target.value) })}
            onBlur={() => save({ enabled: s.enabled, delay_days: s.delay_days })}
            className="w-14 border border-zinc-300 rounded px-2 py-1 text-[12px]" /> days
        </label>
        <button data-testid="nurture-toggle" disabled={busy} onClick={() => save({ enabled: !s.enabled, delay_days: s.delay_days })}
          className={`relative w-11 h-6 rounded-full transition-colors ${s.enabled ? "bg-[var(--e360-primary)]" : "bg-zinc-300"}`}>
          <span className={`absolute top-0.5 left-0.5 w-5 h-5 bg-white rounded-full transition-transform ${s.enabled ? "translate-x-5" : ""}`} />
        </button>
        <span className="text-[12px] font-semibold w-8" style={{ color: s.enabled ? "var(--e360-primary)" : "#a1a1aa" }}>{s.enabled ? "On" : "Off"}</span>
      </div>
    </div>
  );
}
